module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectGas),
      callback: function($$v) {
        _vm.selectGas = $$v
      },
      expression: "selectGas"
    }
  }, _vm._l((_vm.gasList), function(item) {
    return _c('el-option', {
      key: item['油站代码'],
      attrs: {
        "label": item['加油站名称'],
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": _vm.selectGas['加油站名称'],
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gas-info"
  }, [_c('div', {
    staticClass: "info-one"
  }, [_vm._v("\n      " + _vm._s(_vm.selectGas['单位名称']) + "    -    " + _vm._s(_vm.selectGas['区域']) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("通行证限制:")]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_vm._v("\n        " + _vm._s(_vm.getTextTXZ(_vm.selectGas['通行证']) || '无') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("车轴限制:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "无限制"
    },
    model: {
      value: (_vm.axle_key),
      callback: function($$v) {
        _vm.axle_key = $$v
      },
      expression: "axle_key"
    }
  }, _vm._l((_vm.AXLE_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "info-one",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('span', {
    staticStyle: {
      "min-width": "8rem"
    }
  }, [_vm._v("指定配送车辆:")]), _vm._v(" "), _c('div', {
    staticClass: "car-list"
  }, [(!_vm.xzCarList || _vm.xzCarList.length === 0) ? _c('strong', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("没有配送车辆限制")]) : _vm._l((_vm.xzCarList), function(data) {
    return _c('span', [_vm._v(_vm._s(data['车牌号'])), _c('i', {
      staticClass: "icon-105 iconfont",
      on: {
        "click": function($event) {
          _vm.delXzCar(data)
        }
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("添加车辆:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectCar),
      callback: function($$v) {
        _vm.selectCar = $$v
      },
      expression: "selectCar"
    }
  }, _vm._l((_vm.carList), function(item, index) {
    return _c('el-option', {
      key: item['车牌号'] + index,
      attrs: {
        "label": item['车牌号'],
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "油品油罐",
      "actions": _vm.titleAction2
    },
    on: {
      "clickMenu": _vm.clickTitleMenuG
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingG),
      expression: "loadingG"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.oilGGList,
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNew ? '新增加油站' : '修改加油站',
      "visible": _vm.showAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [(_vm.isNew) ? _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油站代码")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['油站代码']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '油站代码', $$v)
      },
      expression: "gasMap['油站代码']"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("加油站名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['加油站名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '加油站名称', $$v)
      },
      expression: "gasMap['加油站名称']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("区域")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['区域']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '区域', $$v)
      },
      expression: "gasMap['区域']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("单位名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['单位名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '单位名称', $$v)
      },
      expression: "gasMap['单位名称']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGas
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNewG ? '新增油罐' : '修改油罐',
      "visible": _vm.showAddG
    },
    on: {
      "update:visible": function($event) {
        _vm.showAddG = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油站代码")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['油站代码']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油站代码', $$v)
      },
      expression: "gasGMap['油站代码']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("罐号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": !_vm.isNewG,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['罐号']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '罐号', $$v)
      },
      expression: "gasGMap['罐号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.gasGMap['油品名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油品名称', $$v)
      },
      expression: "gasGMap['油品名称']"
    }
  }, _vm._l((_vm.OIL_TYPES), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油罐状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.gasGMap['油罐状态']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油罐状态', $$v)
      },
      expression: "gasGMap['油罐状态']"
    }
  }, _vm._l((_vm.GASG_STATUS), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("物理容积")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['物理容积']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '物理容积', $$v)
      },
      expression: "gasGMap['物理容积']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("停泵库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['停泵库存']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '停泵库存', $$v)
      },
      expression: "gasGMap['停泵库存']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("有效容积")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['有效容积']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '有效容积', $$v)
      },
      expression: "gasGMap['有效容积']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAddG = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGasG
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDel,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDel = $event
      }
    }
  }, [(_vm.delType === 'gas') ? [_c('span', [_vm._v("你确定删除该加油站吗？")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("该加油站相关数据也将被删除")])] : [_c('span', [_vm._v("你确定删除该油罐吗？")]), _c('br')], _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delGas
    }
  }, [_vm._v("确 定")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d4ec032","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/gas.vue
// module id = 975
// module chunks = 1